import React from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';
import SessionSection from '../SessionSection';
import { AgendaContextConsumer } from '../AgendaContextProvider';
import { SessionSponsorsElement } from '../SessionSponsors';

export default ({
    session,
    siteConf: {
        color1, isWidget
    },
    showCompactLists,
    stickSectionsToLeft,
    displayInContainer
}) => {
    const { sponsors, sponsorsTitle, id } = session || {};
    const speakerChildrenClass = classnames('session-page-list', {'session-sponsors-compact': showCompactLists});
    return sponsors?.length
        ? <SessionSection
            title={sponsorsTitle || 'Sponsored By:'}
            classTitle="text-ellipsis"
            className="session-sponsors-container"
            color={color1}
            stickSectionsToLeft={stickSectionsToLeft}
            classChildren={speakerChildrenClass}
        >
            <div className='bz-flex-row wrap'>
                {sponsors.map((sponsor) => {
                    const colClass = classnames(
                        'padding-left-none margin-bottom-small itemSponsor sponsor-tile',
                        {
                            'col-lg-12': showCompactLists,
                            'col-md-6 col-sm-6 sponsors-session-page': !showCompactLists});
                    return <Col key={sponsor.id} className={colClass}>
                        <AgendaContextConsumer>
                            {(context) =>
                                <SessionSponsorsElement
                                    sponsor={sponsor}
                                    showCompactLists={showCompactLists}
                                    sizeImage="large"
                                    classInfo="margin-top-small"
                                    isWidget={isWidget}
                                    context={context}
                                    sessionId={id}
                                    displayInContainer={displayInContainer}
                                />
                            }
                        </AgendaContextConsumer>
                    </Col>;
                })}
            </div>
        </SessionSection>
        : null;
};
